import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/welcome/welcome.page').then(m => m.WelcomePage)
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.routes').then(m => m.routes)
  },
  {
    path: 'story/:name',
    loadComponent: () => import('./pages/story/story.page').then(m => m.StoryPage)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

